export default __webpack_public_path__ + "static/media/banana1.ae07c914.svg";